module.exports = __webpack_public_path__ + "static/media/sun_cloud_rain.16021e11.svg";